import type { TDatadogErrorLog } from 'utils/datadog/types'

export const GET_BRANDS_REASONING_LOG: TDatadogErrorLog = {
  from: 'src/hooks/useReasonings',
  name: 'Get Brands Reasoning',
  message: 'Fetch list of reasonings on soa brand category',
}
